import { useTranslate, HttpError } from '@refinedev/core';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input, Select } from 'antd';
import type {
  OrganizationOut,
  OrganizationUpdateIn,
} from '@/api/generated/schemas';
import { OrganizationStatus } from '@/api/generated/schemas';

export const OrganizationEdit = () => {
  const t = useTranslate();
  const { formProps, saveButtonProps } = useForm<
    OrganizationOut,
    HttpError,
    OrganizationUpdateIn
  >({
    resource: 'tenancy.organizations',
    mutationMeta: { method: 'patch' },
  });

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          name="name"
          label={t('tenancy.organizations.fields.name')}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="status"
          label={t('tenancy.organizations.fields.status')}
        >
          <Select
            options={Object.values(OrganizationStatus).map((value) => ({
              label: t(`tenancy.organizations.status.${value}`),
              value,
            }))}
          />
        </Form.Item>
      </Form>
    </Edit>
  );
};
